/**
 * Amber theme
 * Based on Material Design | amber
 * @type {ITheme}
 */
var amber = {
  backgroundColor: "#FFC107",
  color: "black",
  markerColor: "#FF6F00",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#FFE57F",
  pagerColorActive: "#FFC400",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Blue theme
 * Based on Material Design | blue
 * @type {ITheme}
 */

var blue = {
  backgroundColor: "#2196F3",
  color: "black",
  markerColor: "#0D47A1",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#82B1FF",
  pagerColorActive: "#2979FF",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Cyan theme
 * Based on Material Design | cyan
 * @type {ITheme}
 */

var cyan = {
  backgroundColor: "#00BCD4",
  color: "black",
  markerColor: "#006064",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#84FFFF",
  pagerColorActive: "#00E5FF",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
var dark = {
  backgroundColor: "black",
  color: "white",
  markerColor: "#FAFAFA",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#9E9E9E",
  pagerColorActive: "#616161",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Deep orange theme
 * Based on Material Design | deep orange
 * @type {ITheme}
 */

var deepOrange = {
  backgroundColor: "#FF5722",
  color: "black",
  markerColor: "#BF360C",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#FF9E80",
  pagerColorActive: "#FF3D00",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Deep pirple theme
 * Based on Material Design | deep purple
 * @type {ITheme}
 */

var deepPurple = {
  backgroundColor: "#673AB7",
  color: "white",
  markerColor: "#311B92",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#B388FF",
  pagerColorActive: "#651FFF",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Green theme
 * Based on Material Design | green
 * @type {ITheme}
 */

var green = {
  backgroundColor: "#4CAF50",
  color: "black",
  markerColor: "#1B5E20",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#B9F6CA",
  pagerColorActive: "#00E676",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Indigo theme
 * Based on Material Design | Indigo
 * @type {ITheme}
 */

var indigo = {
  backgroundColor: "#3F51B5",
  color: "white",
  markerColor: "#1A237E",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#8C9EFF",
  pagerColorActive: "#3D5AFE",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Light theme
 * A simple monochrome light theme
 * @type {ITheme}
 */

var light = {
  backgroundColor: "white",
  color: "black",
  markerColor: "#212121",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#9E9E9E",
  pagerColorActive: "#EEEEEE",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Light blue theme
 * Based on Material Design | light blue
 * @type {ITheme}
 */

var lightBlue = {
  backgroundColor: "#03A9F4",
  color: "black",
  markerColor: "#01579B",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#80D8FF",
  pagerColorActive: "#00B0FF",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Light green theme
 * Based on Material Design | light green
 * @type {ITheme}
 */

var lightGreen = {
  backgroundColor: "#8BC34A",
  color: "black",
  markerColor: "#33691E",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#CCFF90",
  pagerColorActive: "#76FF03",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Lime theme
 * Based on Material Design | lime
 * @type {ITheme}
 */

var lime = {
  backgroundColor: "#CDDC39",
  color: "black",
  markerColor: "#827717",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#F4FF81",
  pagerColorActive: "#C6FF00",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Orange theme
 * Based on Material Design | orange
 * @type {ITheme}
 */

var orange = {
  backgroundColor: "#FF9800",
  color: "black",
  markerColor: "#E65100",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#FFD180",
  pagerColorActive: "#FF9100",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Pink theme
 * Based on Material Design | pink
 * @type {ITheme}
 */

var pink = {
  backgroundColor: "#E91E63",
  color: "white",
  markerColor: "#880E4F",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#FF80AB",
  pagerColorActive: "#F50057",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Purple theme
 * Based on Material Design | purple
 * @type {ITheme}
 */

var purple = {
  backgroundColor: "#9C27B0",
  color: "white",
  markerColor: "#4A148C",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#EA80FC",
  pagerColorActive: "#D500F9",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Red theme
 * Based on Material Design | Red
 * @type {ITheme}
 */

var red = {
  backgroundColor: "#F44336",
  color: "white",
  markerColor: "#B71C1C",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#FF8A80",
  pagerColorActive: "#FF1744",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Teal theme
 * Based on Material Design | teal
 * @type {ITheme}
 */

var teal = {
  backgroundColor: "#009688",
  color: "white",
  markerColor: "#004D40",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#A7FFEB",
  pagerColorActive: "#1DE9B6",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
/**
 * Yellow theme
 * Based on Material Design | yellow
 * @type {ITheme}
 */

var yellow = {
  backgroundColor: "#FFEB3B",
  color: "black",
  markerColor: "#F57F17",
  markerWidth: "2px",
  pagerBackgroundColor: "none",
  pagerColor: "#FFFF8D",
  pagerColorActive: "#FFEA00",
  pagerGap: "1rem",
  pagerSize: "1.5rem",
  strokeWidth: "2px"
};
export { amber, blue, cyan, dark, deepOrange, deepPurple, green, indigo, light, lightBlue, lightGreen, lime, orange, pink, purple, red, teal, yellow };